import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Users, Settings, ArrowRight, ArrowRightLeft, ShoppingBag, ChevronRight, Globe } from "lucide-react";
import useToken from "../../hooks/auth/useToken";

interface SidebarProps {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
}

interface MenuItem {
  icon: React.ComponentType<any>;
  label: string;
  route: string;
  badge?: string | null;
  externe?: boolean;
  externeLink?: string;
}

const cms_kafintech_url = `https://cms.kafintechgroup.com`;

// Sidebar Component
export const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, setIsCollapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useToken();

  const menuItems: MenuItem[] = [
    { icon: Home, label: "Dashboard", route: "/dashboard", badge: null },
    { icon: Users, label: "Utilisateurs", route: "/users", badge: "12" },
    { icon: Users, label: "Administrateurs", route: "/users", badge: "12" },
    { icon: ArrowRightLeft, label: "Izilife Pay", route: "/izilife-pay/dashboard", externe: false },
    { icon: Globe, label: "CMS Kafintech", route: "/izilife-pay/dashboard", externe: true },
    { icon: ShoppingBag, label: "EasyLife Market", route: "/easylife-market/dashboard", externe: true },
    { icon: Settings, label: "Paramètres", route: "/settings" },
  ];

  const handleNavigation = (route: string, externe?: boolean) => {
    if (externe) {
      window.open(route, "_blank");
    } else {
      navigate(route);
    }
  };

  const isActiveRoute = (route: string) => location.pathname === route;

  return (
    <div
      className={`bg-white border-r border-gray-200 transition-all duration-300 ${isCollapsed ? "w-16" : "w-64"} h-full flex flex-col`}
    >
      {/* Header */}
      <div className="p-4 border-b border-gray-200">
        <div className="flex justify-between items-center">
          {!isCollapsed ? (
            <div className="flex items-center space-x-2">
              <div className="flex justify-center items-center w-8 h-8 bg-green-600 rounded-lg">
                <span className="text-sm font-bold text-white">ILP</span>
              </div>
              <span className="font-bold text-gray-800">Izi Life Pay</span>
            </div>
          ) : (
            <div className="flex justify-center items-center mx-auto w-8 h-8 bg-green-600 rounded-lg">
              <span className="text-sm font-bold text-white">ILP</span>
            </div>
          )}
        </div>
      </div>

      {/* Menu Items */}
      <nav className="flex-1 p-4 overflow-y-auto">
        <ul className="space-y-2">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            const isActive = isActiveRoute(item.route);

            return (
              <li key={index}>
                <button
                  onClick={() => handleNavigation(item.route, item.externe)}
                  className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors ${
                    isActive
                      ? "text-green-700 bg-green-50 border-r-2 border-green-600"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-800"
                  }`}
                >
                  <Icon className="flex-shrink-0 w-5 h-5" />
                  {!isCollapsed && (
                    <>
                      <span className="flex-1 flex items-center">{item.label}</span>
                      {item.externe && <ChevronRight className="w-5 h-5 mr-1" />}
                    </>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};
